import { ready } from "./utils.js";

// Falls "ready" deine eigene DOM-ready-Funktion ist:
ready(() => {
  const flag = document.getElementById("flag");

  function updateHeaderScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 250) {
      flag.classList.add("show");
    } else if (scrollY < 200) {
      flag.classList.remove("show");
    }
  }

  if (flag) {
    window.addEventListener("scroll", updateHeaderScrollClasses, { passive: true });
    updateHeaderScrollClasses(); // initialer Zustand nach Reload
  }
});


